import Instance from '../../../Axios';

// New Actions for the app

const GetPermissoes = () => async (dispatch) => {
  await Instance()
    .get(`/permissoes`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: 'GET_PERMISSOES', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPermissoes;
